<template>
  <v-app
    id="ezb"
    :style="`background-color: ${this.user.config.parameters.parameters.colorbackground}; color: ${this.user.config.parameters.parameters.colorfont};`"
  >
    <InfoDebug />
    <v-container>
      <router-view />
    </v-container>
    <PoweredByAutoIt ></PoweredByAutoIt>
    <ModalError />
  </v-app>
</template>

<script>
import Vue from 'vue';
import settings from './settings/settings';
import helpers from './settings/helpers';
import InfoDebug from '@/components/InfoDebug.vue';
import ModalError from '@/components/ModalError.vue';
import PoweredByAutoIt from '@/components/fragments/PoweredByAutoIt.vue';
import { createNamespacedHelpers } from 'vuex';
import $axios from './settings/axios';
const { mapGetters } = createNamespacedHelpers('user');

export default Vue.extend({
  name: 'EasyBooking',
  components: {
    InfoDebug,
    ModalError,
    PoweredByAutoIt
  },
  beforeMount() {
    this.setSettings(this);
    this.setContainerId(this);
    this.setHost(this);
    this.setStartupError(this);
    if (!this.user.errors.app) {
      this.setLanguage(this);
      this.setRooftopIds(this);
      this.setRooftopId(this);
      this.setKilometers(this);
      this.setRegistrationPlate(this);
      this.setServices(this);
      this.setTokenPolicy(this);
      this.setSpecificDepartments(this);
      this.setCarBrands(this);
      this.setPickuptimeOverwrite(this);
      this.setForwardingEndpoint(this);
      this.setMarketingconsenttext(this);
    }
  },
  mounted() {
    this.setTheme(this);
  },
  data() {
    return {
      kilometers: '',
      registrationplate: '',
      container: '',
      host: ''
    };
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    setTheme: (that) => {
      //Set default primary, secondary and background if unset.
      //TODO: Implement better themeing, and have a default theme file to retrieve variables from.
      that.user.config.parameters.parameters.colorprimary ||= '#02a2b7';
      that.user.config.parameters.parameters.colorsecondary ||= '#222222';
      that.user.config.parameters.parameters.colorbackground ||= '#ffffff';

      that.$vuetify.theme.themes.light.primary = that.user.config.parameters.parameters.colorprimary;
      that.$vuetify.theme.themes.light.accent = that.user.config.parameters.parameters.colorprimary;
      that.$vuetify.theme.themes.light.info = that.user.config.parameters.parameters.colorsecondary;
      that.$vuetify.theme.themes.light.background = that.user.config.parameters.parameters.colorbackground;
    },
    setLanguage: (that) => {
      if (settings.parameters.culture) {
        that.$store.dispatch('user/initConfigLanguage', settings.parameters.culture);
        that.$i18n.locale = that.user.config.language;
        that.$vuetify.lang.current = that.user.config.language;

        // fetch kald til at gribe objekt fra API og derefter overlever object til system

        const payload = {
          endpoint: that.user.config.parameters.api + '/culture/validation',
          params: {
            traceid: that.user.guid,
            culture: that.user.config.parameters.parameters.culture
          }
        };
        that.$store.dispatch('user/initGetCulture', payload).then(() => {});
      }
    },
    setContainerId: (that) => {
      if (settings.container) {
        that.container = settings.container;
        that.$store.dispatch('user/initConfigContainer', that.container);
      }
    },
    setHost: (that) => {
      if (settings.host) {
        that.host = settings.host;
        that.$store.dispatch('user/initConfigHost', that.host);
      }
    },
    setSettings: (that) => {
      that.$store.dispatch('user/initGuid', helpers.createGuid());
      const payload = {
        endpoint: settings.api + '/department/widgetconfiguration',
        params: {
          traceid: that.user.guid,
          customwidgetconfigurationvalue: settings.parameters
        }
      };
      $axios.post(payload.endpoint, payload.params).then((response) => {
          settings.parameters = response.data;
        }
      );
      that.$store.dispatch('user/initConfigParameters', settings);
    },
    setStartupError: (that) => {
      if (settings.parameters.rooftopids === undefined || settings.parameters.rooftopids.length < 1) {
        const errorPayload = {
          modal: true,
          send: false,
          traceid: that.user.guid,
          error: {
            message: 'GET_ROOFTOPS',
            jsondata: JSON.stringify({ message: 'no rooftop ids' })
          }
        };
        that.$store.dispatch('errors/setDataGeneral', errorPayload);
      }
    },
    setRooftopIds: (that) => {
      if (settings.parameters.rooftopids) {
        that.$store.dispatch('user/initRooftopIds', that.user.config.parameters.parameters.rooftopids.replace(/\s+/g, '').split(','));
      }
    },
    setRooftopId: (that) => {
      if (settings.parameters.rooftopid) {
        that.$store.dispatch('user/initSelectedRooftopid', settings.parameters.rooftopid);
      }
    },
    setCarBrands: (that) => {
      if (settings.parameters.carbrands) {
        var carbrandsUpperCase = that.user.config.parameters.parameters.carbrands.replace(/\s+/g, '').toUpperCase();
        that.$store.dispatch('user/initCarBrands', carbrandsUpperCase.split(','));
      }
    },
    setKilometers: (that) => {
      if (settings.kilometers) {
        that.kilometers = Math.floor(settings.kilometers);
        that.$store.dispatch('user/initKilometers', that.kilometers);
      }
    },
    setRegistrationPlate: (that) => {
      if (settings.registrationplate) {
        that.registrationplate = settings.registrationplate;
        that.$store.dispatch('user/initRegistrationPlate', that.registrationplate);
      }
    },
    setServices: (that) => {
      if (settings.services !== null) {
        that.$store.dispatch('user/initServicesBulk', settings.services).then(() => {
          that.$store.dispatch('user/initServicesTime', that.setTotalTime());
        });
      }
    },
    setTotalTime() {
      let time = 0;
      this.user.services.forEach((item) => {
        time += item.jobtime;
      });

      let hours = time / 60;
      let rhours = Math.floor(hours);
      let minutes = (hours - rhours) * 60;
      let rminutes = Math.round(minutes);
      let data = { hours: rhours, minutes: rminutes };
      return data;
    },
    setTokenPolicy: (that) => {
      const payload = {
        endpoint: settings.api + '/authentication/tokenpolicy',
        params: {
          rooftopid: that.user.selectedRooftopid !== '' ? that.user.selectedRooftopid : that.user.rooftopids[0],
          traceid: that.user.guid
        }
      };
      that.$store.dispatch('user/initTokenPolicy', payload);
    },
    setSpecificDepartments: (that) => {
      const payload = {
        endpoint: settings.api + '/department',
        params: {
          rooftopids: that.user.rooftopids,
          traceid: that.user.guid,
          test: that.user.config.parameters.parameters.test
        }
      };
      that.$store.dispatch('user/initListSpecificDepartments', payload).then(() => {
        that.setToken(that);
      });
    },
    setToken: (that) => {
      const payload = {
        endpoint: that.user.config.parameters.api + '/authentication/GetToken',
        params: {
          rooftopid: that.user.selectedRooftopid !== '' ? that.user.selectedRooftopid : that.user.rooftopids[0],
          traceid: that.user.guid,
          test: that.user.config.parameters.parameters.test
        }
      };
      that.$store.dispatch('user/initToken', payload).then(() => {
        if (that.user.lists.departments.output.length === 1) {
          const data = {
            change: true,
            response: that.user.lists.departments.output[0]
          };
          that.$store.dispatch('user/initDepartment', data);
          that.$store.dispatch('user/initLoading', false);
        } else if (that.user.selectedRooftopid) {
          let filtered = that.user.lists.departments.output.filter(function (item) {
            return item.rooftopid === that.user.selectedRooftopid;
          });
          if (filtered.length === 1) {
            const data = {
              change: false,
              response: filtered[0]
            };
            that.$store.dispatch('user/initDepartment', data);
          }
          that.$store.dispatch('user/initLoading', false);
        }
      });
    },
    setPickuptimeOverwrite: (that) => {
      // BWSOL2-495  til Andersen & Martini A/S
      const pickuptimeoverwrite = that.user.config.parameters.parameters.pickuptimeoverwrite;
      if (pickuptimeoverwrite != '' && typeof pickuptimeoverwrite == 'string') {
        that.$store.dispatch('user/initPickuptimeOverwrite', pickuptimeoverwrite);
      }
    },
    setForwardingEndpoint: (that) => {
      // BWSOL2-500 til Kia Import Danmark A/S
      const parameter = that.user.config.parameters.parameters.forwardingendpoint;
      if (parameter != '' && typeof parameter == 'string') {
        that.$store.dispatch('user/initForwardingEndpoint', parameter);
      }
    },
    setMarketingconsenttext: (that) => {
      // BWSOL2-500 til Kia Import Danmark A/S
      const parameter = that.user.config.parameters.parameters.marketingconsenttext;
      if (parameter != '' && typeof parameter == 'string') {
        that.$store.dispatch('user/initMarketingConsentText', parameter);
      }
    }
  }
});
</script>

<style lang="scss"></style>
